import { useContext } from 'react';
//
import { CompanyContext } from 'src/contexts/CompanyContext';

const useCompany = () => {
  const context = useContext(CompanyContext);

  if (!context) throw new Error('Company context must be use inside CompanyProvider');

  return context;
};

export default useCompany;